<input (change)="onChange($event)" type="file" id="actual-btn" hidden/>
<label for="actual-btn">{{'Select a file' | translate}}</label>
<span id="file-chosen">{{selectedFileName|translate}}</span>
